module.exports = __webpack_public_path__ + "media/images/money_icon-34e50d35dc55f46e7defe3c3e8bb7eff.svg";